import Button from "@mui/material/Button";
import type { ButtonProps } from "@mui/material/Button";
import Stack from "@mui/material/Stack";

interface EmptyContactPeopleProps {
	title?: string;
	message?: string;
	withButton?: boolean;
	buttonLabel?: string;
	buttonProps?: Omit<ButtonProps, "className">;
}

const EmptyPeoples = (props: EmptyContactPeopleProps) => {
	const {
		title = "Invite your colleagues to HEMI Teams",
		message,
		withButton = true,
		buttonLabel = "Invite Colleagues",
		buttonProps,
	} = props;

	return (
		<Stack
			spacing={2}
			justifyContent="center"
			alignItems="center"
			className="h-full"
		>
			<div className="w-fit bg-white rounded-[2.5rem] p-4">
				<svg
					width="80"
					height="81"
					viewBox="0 0 80 81"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<title>SVG</title>
					<path
						opacity="0.3"
						d="M30 33.8322C32.7614 33.8322 35 31.5936 35 28.8322C35 26.0707 32.7614 23.8322 30 23.8322C27.2386 23.8322 25 26.0707 25 28.8322C25 31.5936 27.2386 33.8322 30 33.8322Z"
						fill="#71717A"
					/>
					<path
						opacity="0.3"
						d="M14.4667 57.1654H45.5333C42.7333 55.2321 35.9667 52.9988 30 52.9988C24.0333 52.9988 17.2667 55.2321 14.4667 57.1654Z"
						fill="#71717A"
					/>
					<path
						d="M30 40.4987C36.4333 40.4987 41.6666 35.2654 41.6666 28.8321C41.6666 22.3987 36.4333 17.1654 30 17.1654C23.5666 17.1654 18.3333 22.3987 18.3333 28.8321C18.3333 35.2654 23.5666 40.4987 30 40.4987ZM30 23.8321C32.7666 23.8321 35 26.0654 35 28.8321C35 31.5987 32.7666 33.8321 30 33.8321C27.2333 33.8321 25 31.5987 25 28.8321C25 26.0654 27.2333 23.8321 30 23.8321ZM30 46.3321C22.2 46.3321 6.66663 50.2321 6.66663 57.9987V63.8321H53.3333V57.9987C53.3333 50.2321 37.8 46.3321 30 46.3321ZM14.4666 57.1654C17.2666 55.2321 24.0333 52.9987 30 52.9987C35.9666 52.9987 42.7333 55.2321 45.5333 57.1654H14.4666ZM53.4666 46.5321C57.3333 49.3321 60 53.0654 60 57.9987V63.8321H73.3333V57.9987C73.3333 51.2654 61.6666 47.4321 53.4666 46.5321ZM50 40.4987C56.4333 40.4987 61.6666 35.2654 61.6666 28.8321C61.6666 22.3987 56.4333 17.1654 50 17.1654C48.2 17.1654 46.5333 17.5987 45 18.3321C47.1 21.2987 48.3333 24.9321 48.3333 28.8321C48.3333 32.7321 47.1 36.3654 45 39.3321C46.5333 40.0654 48.2 40.4987 50 40.4987Z"
						fill="#71717A"
					/>
				</svg>
			</div>
			<p className="font-bold text-base text-center">{title}</p>
			{message ? (
				<p className="font-normal text-sm text-center">{message}</p>
			) : null}
			{withButton ? (
				<Button
					size="large"
					variant="contained"
					color="primary"
					className="uppercase !rounded-full"
					{...buttonProps}
				>
					{buttonLabel}
				</Button>
			) : null}
		</Stack>
	);
};

export default EmptyPeoples;
